import { actions } from '@saucelabs/sl-module-root-cause';

import { NAMESPACE } from './types';

export default actions.createRootCauseActions(NAMESPACE);
